<template>
  <div class="row" >
    <div class="col-md-6">
      <loading-card v-if="isLoadingPools" title="Pools" />
      <card v-else class="card" title="Pools">
        <ul class="list-group list-group-flush">
          <li class="list-group-item d-flex justify-content-between align-items-center" v-for="pool in userPools" :key="pool.id">
            <span class="p">{{ pool | poolName }}</span>
            <span class="badge badge-pill" :class="{'badge-info': pool.count > 0, 'badge-secondary': pool.count <= 0}">{{ pool.count }} available</span>
          </li>
        </ul>
      </card>
    </div>
    <div class="col-md-6">
      <card class="card" title="Request License">
        <div class="alert alert-success" v-if="successResponse">
          <template v-if="successResponse.response_key">
            <h6 class="success-header">Response Key</h6>
            <div class="input-container">
              <input id="response-key" class="mono-font input-field" readonly :value="successResponse.response_key">
              <button class="btn icon" @click="copyKey">COPY</button>
            </div>
          </template>
          <hr v-if="successResponse.response_key && successResponse.transaction">
          <template v-if="successResponse.transaction">
            <h6 class="success-header">Success</h6>
            <span>{{ successResponse.transaction.count }} {{ 'license' | pluralise(successResponse.transaction.count) }} requested from {{ user.group.name }} on {{ successResponse.transaction.created_at | prettyDate }}.</span>
          </template>
        </div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-12">
              <select class="form-control" v-model="selectedLicenseType">
                <option value="disk_erasure" selected>Disk Erasure: per disk</option>
                <option value="disk_verification">Disk Verification: per disk</option>
                <option value="mobile_erasure">Mobile Erasure: per device</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <fg-input type="text"
                placeholder="License Key"
                :class="{ 'form-group--error': $v.key.$error }"
                v-model="$v.key.$model">
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <textarea placeholder="Notes"
                  class="form-control"
                  v-model="notes"></textarea>
              </div>
            </div>
          </div>
          <div class="text-left">
            <p-button type="info"
              :loading="isLoading"
              @click.native.prevent="requestKey">
              Make Request
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
import LoadingCard from '../components/Cards/LoadingCard.vue';
import Card from '../components/Cards/Card.vue';
import ziperase from '../services/ziperase';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { notify } from '../services/notify';

export default {
  components: {
    LoadingCard,
    Card
  },
  data() {
    return {
      key: "",
      selectedLicenseType: "disk_erasure",
      notes: "",
      isLoading: false,
      isLoadingPools: false,
      responseCode: "",
      successResponse: null,
    }
  },
  validations: {
    key: { required }
  },
  created() {
    this.fetchPools();
  },
  methods: {
    async requestKey() {
      this.successResponse = null;
      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error('Please provide a license key.')
        return;
      }

      try {
        this.isLoading = true;
        let productName;
        let licenseTypeName;
        if (this.selectedLicenseType === 'disk_erasure') {
          productName = 'Disk Erasure';
          licenseTypeName = 'per disk';
        }
        else if (this.selectedLicenseType === 'disk_verification') {
          productName = 'Disk Verification';
          licenseTypeName = 'per disk';
        }
        else if (this.selectedLicenseType === 'mobile_erasure') {
          productName = 'Mobile Erasure';
          licenseTypeName = 'per device';
        }
        const response = await ziperase.transferLicenseToStore(this.key, productName, licenseTypeName, this.notes);
        this.successResponse = response.data;
        this.fetchPools();
        this.resetForm();
      } catch (error) {
        notify().error('Transfer failed.');
      }
      this.isLoading = false;
    },
    async fetchPools() {
      this.isLoadingPools = true;
      if (!this.user) {
        await this.$store.cache.dispatch('user/fetchMe');
      }
      await this.$store.dispatch('group/fetchGroups', this.user.group);
      this.isLoadingPools = false;
    },
    resetForm() {
      this.key = "";
      this.notes = "";
      this.$v.$reset();
    },
    copyKey() {
      let copyInput = document.getElementById("response-key");
      copyInput.select();
      copyInput.setSelectionRange(0, 99999);

      document.execCommand("copy");
      notify().success('Success! Copied response key to clipboard.');
      copyInput.blur();
    }
  },
  computed: {
    ...mapGetters('group', ['groups']),
    ...mapGetters('user', ['user']),
    userPools() {
      if (!this.groups) {
        return [];
      }
      return this.groups.pools;
    }
  }
};
</script>

<style scoped>
.success-header {
  margin-bottom: 7px;
}

.input-container {
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 5px;
}

.icon {
  padding: 5px;
  min-width: 50px;
  text-align: center;
  border-radius: 0px 5px 5px 0px;
  margin-left: -3px;
  cursor: pointer;
}

.input-field {
  font-size: 16px;
  width: 100%;
  padding: 10px;
  outline: none;
}
</style>
